const triggerLoggedOutRedirect = () => {
    const redirectRoute = '/logout';
    if (window.location.href !== redirectRoute) {
        window.location.href = redirectRoute;
    }
};
export default triggerLoggedOutRedirect;
